import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    /* Rows: header / description / cta / images. The cta joins the header
       row at 600px+, so its row collapses there. */
    .luanne-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    h2 {
      grid-column: 2 / 8;
      grid-row: 2;
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
      margin-bottom: var(--between-row-padding);
    }

    cta-text {
      grid-column: 2 / 8;
      grid-row: 4;
      place-self: start;
      margin-bottom: var(--between-row-padding);
    }

    /* Swatch grid: 2-up mobile, 3-up at 600px, 6- or 8-up at 1024px. */
    .images {
      grid-column: 2 / 8;
      grid-row: 5;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: var(--between-row-padding-lg) var(--between-column-padding-lg);
    }

    .font-size-small {
      /* Swatch captions read at the body scale in the mock. */
      padding-top: calc(10rem / var(--default-rem-px-count));
      font-size: var(--fs-body);
      line-height: var(--lh-body);
      letter-spacing: var(--ls-body);
    }

    .image > img {
      display: block;
      width: 100%;
    }

    .add-border {
      border: 1px solid #ccc;
    }

    @media (min-width: 600px) {
      /* Top-row texts share a first baseline. */
      h2 {
        grid-column: 2 / 10;
        align-self: baseline;
        margin-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .description {
        grid-column: 2 / 10;
        align-self: baseline;
        margin-bottom: calc(60rem / var(--default-rem-px-count));
      }

      cta-text {
        grid-row: 2;
        grid-column: 12 / 14;
        place-self: baseline end;
        margin-bottom: 0;
      }

      .images {
        grid-column: 2 / 14;
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    @media (min-width: 1024px) {
      /* Description moves up beside the header. */
      h2 {
        grid-column: 2 / 5;
      }

      .description {
        grid-row: 2;
        grid-column: 6 / 10;
      }

      .six-per-row {
        grid-template-columns: repeat(6, minmax(0, 1fr));
      }

      .eight-per-row {
        grid-template-columns: repeat(8, minmax(0, 1fr));
      }
    }
  `,
];
